// extracted by mini-css-extract-plugin
export var section = "Slider-module--section--F-jc3";
export var li = "Slider-module--li--cPN9h";
export var bg = "Slider-module--bg--pht86";